var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Vue } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { debounce } from "lodash-es";
const pageWidthShow = width => width === 'auto' ? '自适应页宽' : `${width}px`;
let PageWidthToolbarWidget = class PageWidthToolbarWidget extends Vue {
  constructor() {
    super(...arguments);
    /** 自适应宽度 mbp15 4k 5k 默认缩放 */
    this.dropDownOpt = ['auto', 1152, 1920, 2560];
    /** 下拉菜单可见性 */
    this.visible = false;
    /** 页宽输入框的值v-model */
    this.value = this.designer.pageWidth;
    /** 缓存非 mobile 的值 */
    this.cacheValue = this.isMobile ? 'auto' : this.designer.pageWidth;
  }
  /** 是否为自适应页宽模式 */
  get isAuto() {
    return this.designer.pageWidth === 'auto';
  }
  get isMobile() {
    return this.designer.pageWidth === 'mobile';
  }
  created() {
    // 延迟400ms关闭dropdown
    this.closeDropDownDebounce = debounce(() => this.visible = false, 400);
    const syncWidthFromDesigner = (value, isMobile) => {
      if (isMobile === true) {
        // eslint-disable-next-line no-param-reassign
        value = 'mobile';
      }
      if (value) {
        value !== 'mobile' && (this.cacheValue = value);
        this.value = value;
        localStorage.setItem('uicore:pageWidth', value);
      }
    };
    this.designer.$on('pageWidth-changed-user', syncWidthFromDesigner);
    this.designer.$once('hook:beforeDestroy', () => {
      this.designer.$off('pageWidth-changed-user', syncWidthFromDesigner);
    });
  }
  closeDropDown() {
    this.closeDropDownDebounce();
  }
  stopCloseDropDown() {
    this.closeDropDownDebounce.cancel();
  }
  setPageWidth(value) {
    if (value) {
      value !== 'mobile' && (this.cacheValue = value);
      this.value = value;
      this.designer.setPageWidth(value, value === 'mobile');
      localStorage.setItem('uicore:pageWidth', value);
    }
  }
  /** 包含n个可选页面宽度和一个页宽输入框 */
  renderDropDownItem() {
    const h = this.$createElement;
    const customWidthFlag = this.dropDownOpt.includes(this.cacheValue);
    return h("div", [this.dropDownOpt.map(width => h("div", {
      "key": width,
      "class": ['ucd-toolbarPopMenu-item', width === this.cacheValue && 'isCurrent'],
      "on": {
        "click": () => {
          this.visible = false;
          this.setPageWidth(width);
        }
      }
    }, [pageWidthShow(width)])), h("a-input-number", {
      "class": ['ucd-toolbar-pageWidth-input', !customWidthFlag && 'isCurrent'],
      "attrs": {
        "size": "small",
        "value": '',
        "placeholder": customWidthFlag ? '输入数字' : this.cacheValue,
        "parser": value => {
          // 去除空格取10进制
          const newWidth = parseInt(`${value}`.replace(/\D/g, ''), 10);
          // 限制页宽到[1,9999]
          return Math.max(1, Math.min(9999, newWidth)) || 'auto';
        }
      },
      "on": {
        "change": this.setPageWidth,
        "click": this.stopCloseDropDown
      }
    })]);
  }
  /** 点击按钮后开启下拉菜单 */
  renderDropDown() {
    const h = this.$createElement;
    return h("a-dropdown", {
      "attrs": {
        "visible": this.visible
      }
    }, [h("a-icon", {
      "attrs": {
        "type": "desktop",
        "title": this.isAuto ? this.value : `${this.value}px`
      },
      "class": ['ucd-toolbar-size-icon', this.value !== 'mobile' && 'ucd-toolbar-size-icon-active'],
      "on": {
        "mouseover": () => {
          this.stopCloseDropDown();
          this.visible = true;
        },
        "mouseleave": this.closeDropDown,
        "click": () => this.setPageWidth(this.cacheValue)
      }
    }), h("div", {
      "slot": "overlay",
      "class": "ucd-toolbar-zoom-dropdownMenu",
      "on": {
        "mouseleave": this.closeDropDown,
        "mouseover": this.stopCloseDropDown
      }
    }, [this.renderDropDownItem()])]);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-toolbar-size-container"
    }, [this.renderDropDown(), h("a-icon", {
      "attrs": {
        "type": "mobile"
      },
      "class": ['ucd-toolbar-size-icon', this.value === 'mobile' && 'ucd-toolbar-size-icon-active'],
      "on": {
        "click": () => this.setPageWidth('mobile')
      }
    })]);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], PageWidthToolbarWidget.prototype, "designer", void 0);
PageWidthToolbarWidget = __decorate([Component({
  name: 'PageWidthToolbarWidget'
})], PageWidthToolbarWidget);
export default PageWidthToolbarWidget;
//# sourceMappingURL=PageWidthToolbarWidget.js.map
